import { ChevronRightIcon } from '@heroicons/react/solid';
import { FC, memo } from 'react';
import { BreadcrumbItem } from './types';
import { BreadcrumbLink } from './BreadcrumbLink';

type BreadcrumbListItemProps = {
  item: BreadcrumbItem;
};

const BreadcrumbListItemComp: FC<BreadcrumbListItemProps> = ({ item }) => {
  return (
    <li className='group/breadcrumb flex items-center gap-1'>
      <ChevronRightIcon className='size-5 shrink-0 text-gray-400' aria-hidden='true' />
      <BreadcrumbLink item={item} />
    </li>
  );
};

export const BreadcrumbListItem = memo(BreadcrumbListItemComp);
